import React from 'react'
import posed from 'react-pose'
import styled from 'styled-components'
import Menu from './Menu'
import Social from './Social'
import Contact from './Contact'
import ContactUs from './ContactUs'

const PanelWrapper = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 20;
  &.open {
    background: #b82601;
  }
  @media (min-width: 1024px) {
    height: 100vh;
  }
`

const PanelPose = posed.div({
  open: {
    staggerChildren: 200,
    x: 0,
    opacity: 1
    /*
    transition: {
      default: { type: 'spring', stiffness: 1000, damping: 15 }
    },
    */
  },
  closed: {
    staggerChildren: 100,
    x: "100%",
    opacity: 0
    /*
    transition: {
      default: { type: 'spring', stiffness: 1000, damping: 15 }
    },
    */
  },
  initialPose: 'closed'
});

const PanelMenu = styled(PanelPose)`
  position: relative;
  width: 100vw;
  height: auto;
  z-index: 999;
  background-color: transparent;
  top: 0;
  @media (min-width: 1024px) {
    overflow: hidden;
    height: 100vh;
  }
`

const PanelPose1 = posed.div({
  open: { x: 0, opacity: 1 },
  closed: { x: "100%", opacity: 0 }
});

const ItemPanel1 = styled(PanelPose1)`
  position: relative;
  background: #b82601;
  width: 100vw;
  height: auto;
  box-sizing: border-box;
  top: 0;
  left: 0;
  @media (min-width: 1024px) {
    position: absolute;
    width: 40%;
    height: 100vh;
    top: 0;
    left: 0;
  }
`

const PanelPose2 = posed.div({
  open: { x: "40vw", opacity: 1  },
  closed: { x: "100%", opacity: 0 }
});

const ItemPanel2 = styled(PanelPose2)`
  position: relative;
  background: #062f4f;
  width: 100vw;
  height: auto;
  box-sizing: border-box;
  border-bottom: 2px solid white;
  top: 0;
  left: -40%;
  @media (min-width: 1024px) {
    position: absolute;
    width: 40%;
    height: 100vh;
    top: 0;
    left: 0;
    border-left: 2px solid white;
    border-bottom: none;
  }
`

const PanelPose3 = posed.div({
  open: { x: "80vw", opacity: 1  },
  closed: { x: "100%", opacity: 0 }
});

const ItemPanel3 = styled(PanelPose3)`
  position: relative;
  background: #626e60;
  width: 100vw;
  height: auto;
  box-sizing: border-box;
  border-bottom: 2px solid white;
  top: 0;
  left: -80%;
  @media (min-width: 1024px) {
    position: absolute;
    width: 20vw;
    height: 100vh;
    top: 0;
    left: 0;
    border-left: 2px solid white;
    border-bottom: none;
  }
`

const MenuPanel = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  .main-menu {
    margin-top: 60px;
    @media (min-width: 1024px) {
      margin-top: 80px;
    }
  }
  .social-menu {
    margin-top: auto;
    margin-bottom: 20px;
    @media (min-width: 1024px) {
      margin-bottom: 80px;
    }
  }
`

class Panel extends React.Component {
  render() {
    const { isOpen } = this.props;

    return(
      <PanelWrapper className={isOpen ? 'open' : 'closed'}>
        <PanelMenu className="flex flex-col lg:flex-row" pose={isOpen ? 'open' : 'closed'}>
          <ItemPanel3 className="flex-0">
            <MenuPanel>
              <Menu className="main-menu text-center lg:text-left" isOpen={isOpen}/>
              <Social className="social-menu mb-0 pt-2 lg:pt-5 text-center lg:text-left" isOpen={isOpen}/>
            </MenuPanel>
          </ItemPanel3>

          <ItemPanel2 className="flex-0">
            <ContactUs/>
          </ItemPanel2>

          <ItemPanel1 className="flex-0">
            <Contact/>
          </ItemPanel1>
        </PanelMenu>
      </PanelWrapper>
    )
  }
}

export default Panel
